import { render } from "./Scoreboard.vue?vue&type=template&id=31b0b791&scoped=true"
import script from "./Scoreboard.vue?vue&type=script&lang=js"
export * from "./Scoreboard.vue?vue&type=script&lang=js"

import "./Scoreboard.vue?vue&type=style&index=0&id=31b0b791&lang=scss&scoped=true"

import exportComponent from "/vercel/path3/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b0b791"]])

export default __exports__